'use strict';

export const PLAYING_STATE = {
    error: 'error',
    loading: 'loading',
    paused: 'paused',
    playing: 'playing',
    stopped: 'stopped',
    unknown: 'unknown'
};

export const STATE_CLASS = {
    active: 'svp_is--active',
    animatable: 'svp_is--animatable',
    error: 'svp_is--error',
    externalUi: 'svp_is--external-ui',
    fullscreen: 'svp_is--fullscreen',
    initialUi: 'svp_is--initial-ui',
    pipMode: 'svp_is--pip-mode',
    visible: 'svp_is--visible',
    hidden: 'svp_is--hidden'
};

export const PROPERTY_CLASS = {
    controlsHideInitially: 'svp_ui-controls--hide-initial',
    hideCursor: 'svp_video--hide-cursor',
    isLast: 'svp_ui-is--last'
};

export const FOCUS_ELEMENT_CLASS = 'svp_js-tabfocus';



// WEBPACK FOOTER //
// ./src/js/plugins/ui/ui-constants.js